import { createAction } from '@reduxjs/toolkit';

export const ATTEMPT_RECONNECT_ACTION_TYPE = 'saga/attemptReconnect';
export const attemptReconnectAction = createAction(ATTEMPT_RECONNECT_ACTION_TYPE);
